import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import { v4 as uuidv4 } from 'uuid';

export class ComponentToolClass extends BaseTool {
    id = 'COMPONENT';
    name = 'Component';
    cursor = 'crosshair';

    private rotation = 0;

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;

        const snapped = this.snapToGrid(point);

        // Create a generic component element
        const id = uuidv4();
        const component: any = {
            id,
            category: 'Generic Models',
            type: 'Standard Box', // Default for now
            parameters: {
                'Level': 'Level 1',
                'Rotation': `${(this.rotation * 180 / Math.PI).toFixed(2)}°`
            },
            constraints: [],
            geometryData: {
                position: [snapped.x, snapped.y, snapped.z],
                rotation: this.rotation * 180 / Math.PI, // Store in degrees
                width: 0.5,
                depth: 0.5,
                height: 0.5
            }
        };

        // Add to BIM store
        this.context.bimStore.addElement(component as any);

        // Reset rotation? No, keep it usually.
        // this.rotation = 0;
        this.updatePreview();
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        const point = this.getIntersection(event);
        if (point) {
            const snapped = this.snapToGrid(point);
            this.updatePreview(snapped);
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.code === 'Space') {
            event.preventDefault(); // Prevent scrolling
            this.rotation += Math.PI / 2;
            if (this.rotation >= Math.PI * 2) this.rotation = 0;
            this.updatePreview();
        } else {
            super.onKeyDown(event);
        }
    }

    private currentPreviewPoint: THREE.Vector3 | null = null;

    private updatePreview(point?: THREE.Vector3) {
        if (!this.context) return;
        if (point) this.currentPreviewPoint = point;

        if (this.currentPreviewPoint) {
            this.context.appStore.setToolPreview({
                type: 'component',
                position: [this.currentPreviewPoint.x, this.currentPreviewPoint.y, this.currentPreviewPoint.z],
                rotation: this.rotation
            });
        }
    }

    onPointerUp(): void { }
}
